import ApplicantView from "./ApplicantView.component.jsx";

export default ApplicantView;